module.exports = __webpack_public_path__ + "img/osago-car.d309d95.svg";